'use strict';

const util = require('util');

// Moment performance hack
//
// Moment's string parsing is so slow and invoked so frequently that it bogs down
// the entire server, especially on data-centric tasks like contructing/processing
// metrics.
//
// See https://github.com/RivalIQ/rivaliq-server/issues/34864 for details.
//
// The good news:
//
//      1. The instrinsic Date()'s string parsing is an order of magnitude faster.
//
//      2. The moment() and moment.utc() constructors  and a handful of critical
//         object methods can accept Date objects in lieu of strings.
//
// The strategy here is to wrap the constructors and the critical object methods.
//
// Note: Both moment() and moment.utc() support many different constructor forms based
// on the number of parameters and the parameter types. 90% of our usage is of the form
// moment('string') or moment.utc('string'), while the remainder are of the form
// moment('string', 'format') or moment.utc('string', 'format'). These last two forms
// are not compatible with our Date()-wrapping strategy -- moment('string', 'format')
// produces different results than moment(new Date('string'), 'format'), Same with
// moment.utc(). In the interest of safety we'll only do our Date()-wrapping trick when
// these constructors are invoked with a single string parameter.

const moment = require('moment-timezone');

moment.updateLocale('en', {
    monthsShort: [
        'Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'Jun.',
        'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'
    ]
});

const NAME_PREFIX = 'riq_moment';

// Constructor

const riq_moment = makeWrapper(`${NAME_PREFIX}`, moment);
util.inherits(riq_moment, moment);

// Static class methods

Object.keys(moment).forEach(name => {
    riq_moment[name] = moment[name];
});

['utc'].forEach(method => {
    riq_moment[method] = makeWrapper(`${NAME_PREFIX}_{method}`, riq_moment[method]);
});

// Object methods

['isAfter', 'isBefore', 'isSame', 'isSameOrAfter', 'isSameOrBefore'].forEach(method => {
    riq_moment.prototype[method] = makeWrapper(`${NAME_PREFIX}_{method}`, riq_moment.prototype[method]);
});

// Shenanigans required to create functions with dynamically generated names.
// One does not simply write "function `${NAME_PREFIX}_{name}` { ... }".

function makeWrapper(name, fn) {
    return {
        [name]: function (...args) {
            if (args.length === 1 && typeof args[0] === 'string') {
                args[0] = new Date(args[0]);
            }

            return fn.apply(this, args);
        }
    }[name];
}

module.exports = riq_moment;
